import { get, put, post, postForm, putForm } from 'utils/methods';

export function getResellerApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}resellers`, data, headers);
}

export function editProfileApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_USERS}commands/user`, data, headers);
}

export function editProfilePhotoApi(data, headers) {
    return postForm(`${process.env.REACT_APP_REST_USERS}commands/user/image`, data, headers);
}

export function editResellerApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/reseller`, data, headers);
}

export function editResellerPhotoIconApi(data, headers) {
    return putForm(`${process.env.REACT_APP_REST}commands/reseller`, data, headers);
}

export function userLoginApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_USERS}oauth2/token`, data, headers, undefined);
}

export function userDataApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_USERS}user/info`, data, headers);
}

export function userLogoutApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_USERS}logout`, data, headers);
}
